export const SPACING_A = {
  extraSmall: { size: 20 },
  small: { size: 20 },
  medium: { size: 28 },
  large: { size: 28 },
  extraLarge: { size: 28 }
};

export const SPACING_C = {
  extraSmall: { size: 14 },
  small: { size: 14 },
  medium: { size: 14 },
  large: { size: 14 },
  extraLarge: { size: 14 }
};

export const BUTTON_SQUARE_SIZE = {
  extraSmall: { width: 16 },
  small: { width: 24 },
  medium: { width: 36 },
  'large+extraLarge': { width: 44 }
};

export const TEXT_LEVEL_1_FONT_SIZE_ONLY = {
  'large+extraLarge': { fontSize: 20 },
  medium: { fontSize: 18 },
  'extraSmall+small': { fontSize: 16 }
};
export const TEXT_LEVEL_1_FONT_SIZE = {
  default: { fontSize: 20, fontWeight: 700, display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' },
  medium: { fontSize: 18 },
  small: { fontSize: 16 },
  extraSmall: { fontSize: 16, maxHeight: 15 }
};

export const TEXT_LEVEL_2_FONT_SIZE = {
  default: { fontWeight: 400 },
  'large+extraLarge': { fontSize: 16 },
  medium: { fontSize: 14 },
  'extraSmall+small': { fontSize: 12 }
};
